import {
  CALENDAR_DOC,
  CHECKINS_DOC,
  HOUSEHOLD_DOC,
  LISTS_DOC,
  PERSONAL_CALENDAR_DOC_PREFIX,
  PERSONAL_LISTS_DOC_PREFIX,
} from '@awwyeah/shared';
import type { WebModule } from '../registry';
import { DigestPage } from './DigestPage';

/**
 * Digest module (client side, WS-14). One route, no doc of its own — it's a pure read over
 * four other modules' docs (`calendar`, `household`, `lists` + every `list:<id>`,
 * `checkins`), so it declares them all here rather than depending on those modules also
 * being mounted (a household member might open `/digest` directly from a push, with no
 * other module's page ever having rendered this session).
 *
 * `order: 5` sorts it before Calendar (10); `hideInTabs` keeps it off both the mobile
 * bottom-tab bar and the desktop top nav (`apps/web/src/chrome/`) — it's reachable via the
 * "AwwYeah" wordmark (which links to `/digest`) and the push notification's deep link,
 * without spending one of the nav slots on a page that's genuinely a *summary* of the
 * others.
 */
export const digestWebModule: WebModule = {
  id: 'digest',
  nav: { label: 'Digest', path: '/digest', icon: '☀️', order: 5, hideInTabs: true },
  routes: [{ path: '/digest', component: DigestPage }],
  docs: [
    CALENDAR_DOC,
    PERSONAL_CALENDAR_DOC_PREFIX,
    HOUSEHOLD_DOC,
    LISTS_DOC,
    PERSONAL_LISTS_DOC_PREFIX,
    'list:',
    CHECKINS_DOC,
  ],
};

export { DigestPage } from './DigestPage';
